import { defineComponent as _defineComponent } from 'vue'
import store from '@/store'
import { MediaPanel } from '@/widgets/MediaPanel'
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import { useImage } from '@/shared/composables/image'
import { eventApi, EventDB } from '@/enitites/event'
import { BKModal } from '@/shared/ui/modals'
import BKSvgIcon from '@/components/AppShared/BKSvgIcon.vue'
import { EventFeedbackPostData } from '@/enitites/event/model/types'
import { useQuerySync } from '@/composables/useQuerySync'
import EventBattles from './EventBattles.vue'
import EventStaff from './EventStaff.vue'
import EventSidebar from './EventSidebar.vue'
import EventUserFeedback from './EventUserFeedback.vue'
import EventFeedbackForm from './EventFeedbackForm.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'EventPage',
  setup(__props) {

// @ts-expect-error JS file
const instance = getCurrentInstance()
const { getImageById } = useImage()
const route = useRoute()
const event = ref<EventDB>()
const eventId = computed(() => route.params.id)

const tabSelected = ref<'info' | 'feedback'>('info')
useQuerySync(
  tabSelected,
  'tab',
  (val) => (val === 'feedback' ? 'feedback' : 'info'),
  (val) => val
)

const isShowModal = ref(store.getters.getShowEventInfoModal)

function onModalClose(value: boolean) {
  if (!value) {
    store.dispatch('setShowEventInfoModal', false)
  }
}

async function initEvent() {
  event.value = undefined
  const fetchedEvent = await eventApi.getEvent(Number(eventId.value))
  if (!fetchedEvent) {
    await store.dispatch('setIsNotFound', !fetchedEvent)
    return
  }

  event.value = {
    ...fetchedEvent,
  }
}

function setFeedback(feedback: EventFeedbackPostData) {
  if (!event.value) return
  event.value.feedback = { ...feedback, createdAt: event.value.createdAt || new Date().toISOString() }
}

watch(eventId, () => {
  initEvent()
})

onMounted(() => {
  initEvent()
})

return { __sfc: true,instance, getImageById, route, event, eventId, tabSelected, isShowModal, onModalClose, initEvent, setFeedback, MediaPanel, BKModal, BKSvgIcon, EventBattles, EventStaff, EventSidebar, EventUserFeedback, EventFeedbackForm }
}

})